import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import resolvePath from '../../../misc/resolvePath';
import { useLocation } from 'react-router-dom';

const Link = props => {
    let { href, id, title } = props,
        { pathname } = useLocation()

    if (href && href.indexOf(location.origin) === 0) {
        href = href.replace(location.origin, '');
    }

    if (!href || href.match(/^https?:\/\//) || href.match(/^mailto:/)) {
        return (
            <a
                id={id}
                href={href}
                className={props.className}
                onClick={props.onClick}
                disabled={props.disabled}
                target="_blank"
                rel="noopener noreferrer"
                style={props.style}
                title={title}>
                {props.children}
            </a>
        );
    } else if (href.match(/^\.{0,2}\//)) {
        return (
            <RouterLink
                id={id}
                // the leading slash is dropped so an absolute href replaces the current path
                // instead of being appended to it (see resolvePath)
                to={resolvePath(pathname.replace(/^\//, ''), href)}
                className={props.className}
                onClick={props.onClick}
                disabled={props.disabled}
                style={props.style}
                title={title}>
                {props.children}
            </RouterLink>
        );
    } else {
        return (
            <RouterLink id={id} to={href} className={props.className} onClick={props.onClick} disabled={props.disabled} style={props.style} title={title}>
                {props.children}
            </RouterLink>
        );
    }
};

export default Link;
